import React, { FC, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@material-ui/core";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  text: string;
  colorOfButtonGreen: boolean;
  onConfirmType?: number;
}



const ConfirmDialogOptionalColor: FC<ConfirmDialogProps> = ({ onClose, onConfirm, onConfirmType, open, title, text, colorOfButtonGreen }) => {

  let confirmType = 0

  if (onConfirmType){
    confirmType = onConfirmType
  }

  if (confirmType > 1){
    return (
      <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent>
              <Button variant="contained" fullWidth onClick={onConfirm} style={{backgroundColor: "green", color: "white"}}>
              {text}
              </Button> 
              <div style={{ fontStyle: "italic", fontSize: "10px"}}>
                {(confirmType != 3)
                ?(<>Gem uden at sende en mail til ansøger</>)
                :(<>Gem og send en mail til ansøger</>)
                }
                
              </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} color="primary" autoFocus>
              Annuller
            </Button>
          </DialogActions>
        </Dialog>
    );
  }
  else{
    return (
      <Dialog
          open={open}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
          <DialogContent>
              {(colorOfButtonGreen === false)
              ?(<>
              <Button variant="contained" fullWidth onClick={onConfirm} style={{backgroundColor: "red", color: "white"}}>
              {text}
              </Button>
              </>)
              :(<>
              <Button variant="contained" fullWidth onClick={onConfirm} style={{backgroundColor: "green", color: "white"}}>
              {text}
              </Button> 
              <div style={{ fontStyle: "italic", fontSize: "10px"}}>
              Betalingslinket bliver automatisk tilføjet, hvis prisen ikke er nul.
              </div>
              </>)}
          </DialogContent>
          <DialogActions>
            <Button onClick={onClose} color="primary" autoFocus>
              Annuller
            </Button>
          </DialogActions>
        </Dialog>
    );

  }
}
export default ConfirmDialogOptionalColor;